<template>
    <section class="auth-section forgot-password h-100">
        <div class="container-fluid h-100">
            <div class="row align-items-center h-100">
                <div v-if="lightMood === true" class="col-sm-6 crop1">
                    <img src="../../../assets/images/LoginPageLightMood.png" class="img-fluid logoLarge"/>
                </div>
                <div class="col-sm-6 crop2" v-else>
                    <img src="../../../assets/images/auth-img.svg" class="img-fluid logoLarge"/>

                </div>
                <div v-if="lightMood === true" class="col-sm-6">
                    <div class="auth-form form-width">
                        <div class="imageInLoginLightMood text-center">
                            <img src="../../../assets/images/LogoLightMood.svg" width="200" class="img-fluid logoLarge"/>
                        </div>
                        <form id="forgotPasswordForm" class="pt-5" @submit.prevent="getLink">
                            <div class="row ">
                                <div class="col-12">
                                    <div class="form-group">
                                        <h4 class="form-title mb-4" style="color:var(--main-color)">
                                            Forgot Password
                                        </h4>
                                        <p class="form-light-txt">
                                            Enter your registered email to receive a reset link.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-12 mb-4">
                                    <div class="form-group">
                                        <label for="EmailInput" style="color:var(--main-color)">Email</label>
                                        <input type="email" class="form-control" id="EmailInput" v-model="email"
                                               placeholder="Email@example.com" name="email" @input="changeHandler($event, errors, 'email')">
                                    </div>
                                    <div  v-if="errors['email'].length > 0" >
                                        <div v-for="msg in errors['email']" class="text-danger position-absolute" >{{msg}}</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <div class="">
                                            <button type="submit" class="btn auth-button get-link-btn">Get Link</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div  v-if="errorMessages.length > 0" class="error-container">
                            <div v-for="msg in errorMessages" class="text-danger my-4" >{{msg}}</div>
                        </div>
                        <div v-if="errorMsg">{{errorMsg}}</div>
                        <div v-else>{{errorMsg}}</div>
                    </div>
                    <AlartModal v-if="showModal" :message="message" imagePath="okImage.svg" @close-modal="showModal = false"/>
                </div>
                <div v-else class="col-sm-6">
                    <div class="auth-form form-width">
                        <form id="forgotPasswordForm" @submit.prevent="getLink">
                            <div class="row ">
                                <div class="col-12">
                                    <div class="form-group">
                                        <h4 class="form-title mb-4" style="color:var(--main-color)">
                                            Forgot Password
                                        </h4>
                                        <p class="form-light-txt">
                                            Enter your registered email to receive a reset link.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-12 mb-4">
                                    <div class="form-group">
                                        <label for="EmailInput" style="color:var(--main-color)">Email</label>
                                        <input type="email" class="form-control" id="EmailInput" v-model="email"
                                               placeholder="Email@example.com" name="email" @input="changeHandler($event, errors, 'email')">
                                    </div>
                                    <div  v-if="errors['email'].length > 0" >
                                        <div v-for="msg in errors['email']" class="text-danger position-absolute" >{{msg}}</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <div class="">
                                            <button type="submit" class="btn auth-button get-link-btn">Get Link</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div  v-if="errorMessages.length > 0" class="error-container">
                            <div v-for="msg in errorMessages" class="text-danger my-4" >{{msg}}</div>
                        </div>
                        <div v-if="errorMsg">{{errorMsg}}</div>
                        <div v-else>{{errorMsg}}</div>
                    </div>
                    <AlartModal v-if="showModal" :message="message" imagePath="okImage.svg" @close-modal="showModal = false"/>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    import repository from "../../../api-services/repository";
    import changeHandler from '../../../validation/forgetPasswordValidation';
    import AlartModal from "../../components/AlartModal";

    export default {
        name:'forget-password',
        components:{
            AlartModal
        },
        data(){
            return {
                changeHandler,
                lightMood:null,
                email:null,
                errors:{
                    email:[],
                    isError: false
                },
                showModal:false,
                message:null,
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                errorMsg:'',
            }
        },
        mounted(){
            this.lightMood = this.$store.state.settings.isLightMood;
        },
        computed:{
            lightMood(){
                return this.$store.state.settings.isLightMood;
            }
        },
        methods:{
            async getLink(){
                try{
                    if(this.email == null){
                        this.showModal = true;
                        this.message = 'Please Fill Email Address';
                    }else{
                        if(!this.errors.isError) {
                            const response = await repository.forgetPassword({email: this.email});
                            if(response.status === 200){
                                this.showModal = true;
                                this.message = 'Email Sent Successfully';

                                setTimeout(() => {
                                    this.$router.push({name: 'login-page'});
                                } , 2000);
                            }else{
                                this.showModal = true;
                                this.message = 'User Not Fond';
                            }
                        }
                    }
                }catch(e){
                    console.log(e);
                    if(e.response.data.errors){
                        if(e.response.data.errors.email){
                            if(e.response.data.errors.email)
                                e.response.data.errors.email.forEach((err,idx) => {this.errors['email'][idx] = `* ${err}`});
                        }else{
                            let idx = 0;
                            for (const property in e.response.data.errors) {
                                let record = property.split('.')[0];
                                console.log(`record ${+record + 1}: ${e.response.data.errors[property]}`);
                                this.errors['email'][idx++] = `* record ${+record + 1}: ${e.response.data.errors[property]}` + '\n';
                            }
                        }
                    }else if(e.response.data){
                        this.errorMsg = e.response.data.message;
                        this.showErrorModal = true;
                        this.responseErrorMessage = e.response.data.message
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .auth-section{
        width: 100%;
        height:auto;
        margin: auto 0;
    }

    .auth-section .form-group{
        margin-bottom: .5rem;
        width: 100%;
        position: relative;
    }
    .auth-section .crop1 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 100%;
        background-color: #012F3D;
    }
    .auth-section .crop1 img{
        display: block;
        width: 100%;
        margin-left: -15px;
        max-width: 750px;
    }

    .auth-section .crop2 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .auth-section .crop2 img{
        display: block;
        width: 100%;
        margin-left: -15px;
        max-width: 750px;
    }

    .auth-section .form-light-txt{
        color: var(--main-color);
        line-height: 1.7;
    }


    .auth-button {
        background-color: var(--btn-bg-color);
        width: 100%;
        color: var(--btn-text-color);
        font-weight: bold;
        height: 45px;
        margin-bottom: 0.5rem;
    }

    .auth-button:focus ,
    .auth-button:hover {

        color: var(--btn-text-color);
    }

    .auth-section .p-viewer{
        top: 35px;
        position: absolute;
        right: 7px;
        z-index: 2;
        cursor:pointer;
        color: var(--btn-text-color);
    }

    .auth-section .auth-form{
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        box-shadow: 5px 11px 113px -14px rgba(0,0,0,0.21) inset;
        -webkit-box-shadow: 5px 11px 113px -14px rgba(0,0,0,0.21) inset;
        -moz-box-shadow: 5px 11px 113px -14px rgba(0,0,0,0.21) inset;
        border-radius: 10px;
        padding: 3rem;
        min-height: 63vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .auth-section.register .auth-form{
        min-height: 100vh;
    }

    .auth-section .auth-links{
        margin-left:auto;
        color: var(--btn-text-color);
        text-decoration: underline;
    }
    /*.auth-section .auth-links:hover{*/
    /*    color: #fff;*/
    /*}*/

    .auth-section .form-group input,.auth-section select{
        height: 45px !important;
        background-color: transparent;
        color: var(--main-color);
    }
    .auth-section span.error{
        color:#e95626;
        font-size: 14px;
    }

    .auth-section .error::before{
        content : "* "
    }

    .auth-section form{
        color:white;
    }
    .auth-section input[type=checkbox]
    {
        -ms-transform: scale(1.3); /* IE */
        -moz-transform: scale(1.3); /* FF */
        -webkit-transform: scale(1.3); /* Safari and Chrome */
        -o-transform: scale(1.3); /* Opera */
        transform: scale(1.3);
        padding: 10px;

    }

    .auth-section .center {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
    ::placeholder {
        color: var(--main-color);
        font-style: italic;
    }

    .auth-section .bootstrap-tagsinput {
        background-color: #fff;
        border: 1px solid #ccc;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        display: block;
        padding: 4px 6px;
        color: #555;
        vertical-align: middle;
        border-radius: 4px;
        max-width: 100%;
        line-height: 22px;
        cursor: text;
    }
    .auth-section .bootstrap-tagsinput input {
        border: none;
        box-shadow: none;
        outline: none;
        background-color: transparent;
        padding: 0 6px;
        margin: 0;
        width: auto;
        max-width: inherit;
    }


    .auth-section .form-width{
        max-width: 650px;
        margin: auto;
    }

    .auth-section .brand-group{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .auth-section .brand-group br{
        display: none;
    }
    .auth-section .brand-group .error{
        order: 3;
    }

    .auth-section input[type="checkbox"] {
        width: auto;
        opacity: 0.00000001;
        position: absolute;
        left: 0;
        margin-left: -20px;
    }
    .checkbox {
        width: 100%;
        position: relative;
        display: flex;
        padding-right: 0;
        margin-left: -10px;
        flex-wrap: wrap;
        padding-left: 0;
    }
    .checkbox input[type="checkbox"] {
        width: auto;
        opacity: 0.00000001;
        position: absolute;
        left: 0;
        margin-left: -20px;
    }
    .checkbox label {
        padding-top: 3px;
        min-height: 34px;
        display: flex;
        padding-left: 35px;
        margin-bottom: 0;
        font-weight: normal;
        cursor: pointer;
        vertical-align: middle;
        flex-wrap: nowrap;
        flex-grow: 1;
        position: relative;
    }



    .checkbox label:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        margin: 4px;
        width: 22px;
        height: 22px;
        transition: transform 0.28s ease;
        border-radius: 3px;
        border: 2px solid #e65c00;
    }
    .checkbox label:after {
        content: '';
        display: block;
        width: 10px;
        height: 5px;
        border-bottom: 2px solid #e65c00;
        border-left: 2px solid #e65c00;
        -webkit-transform: rotate(-45deg) scale(0);
        transform: rotate(-45deg) scale(0);
        transition: transform ease 0.25s;
        will-change: transform;
        position: absolute;
        top: 12px;
        left: 10px;
    }
    .checkbox input[type="checkbox"]:checked ~ label::before {
        color: #e65c00;
    }

    .checkbox input[type="checkbox"]:checked ~ label::after {
        -webkit-transform: rotate(-45deg) scale(1);
        transform: rotate(-45deg) scale(1);
    }




    /* media */

    @media (max-height:767px) {
        .auth-section .auth-form{
            padding: 1rem 2rem;
        }
        .auth-section .p-viewer{
            top: 37px;
        }
        .auth-section .form-group input, .auth-section select{
            height: 35px !important;
        }
        .select2-container .select2-selection--multiple{
            min-height: 35px !important;
        }
        .select2-container--default .select2-selection--multiple .select2-selection__choice{
            margin-top: 5px;
        }
        .select2-container .select2-search--inline .select2-search__field{
            margin-top: 5px;
        }
        span.error{
            font-size: 12px;
        }

    }
</style>